export class Gst {
    dGstNo : string;
    dGstAddress : string;
    dGstState : string;
}

